export default {
  dbl_dashboard_list_dashboard_name: "报表名称",
  dbl_dashboard_list_status: "状态",
  dbl_dashboard_list_search_dashboard: "搜索报表名或创建人",
  dbl_dashboard_list_new_dashboard: "新建报表",
  dbl_dashboard_list_my_dashboard: "报表中心",
  dbl_dashboard_access_title_dashboard: "报表权限",
  dbl_dashboard_access_title_chart: "图表权限",
  dbl_dashboard_access_title_cube: "权限",
  dbl_dashboard_access_title_sql_view: "SQL视图权限",
  dbl_dashboard_access_edit: "编辑权限",
  dbl_dashboard_access_info: "报表权限将在图表同步生效。",
  dbl_dashboard_access_chart_info: "此用户列表还可以更改关联的图表。",
  dbl_dashboard_access_success: "编辑权限已修改成功",
  dbl_dashboard_access_error: "编辑权限修改失败！错误代码{code}。",
  dbl_dashboard_access_placeholder: "搜索您想要添加的用户。",
  dbl_dashboard_access_user: "用户",
  dbl_dashboard_access_access: "角色",
  dbl_dashboard_access_add: "添加用户",
  dbl_dashboard_access_viewer: "查看者",
  dbl_dashboard_access_developer: "编辑者（可发布）",
  dbl_dashboard_access_sql_view_developer: "编辑者",
  dbl_dashboard_list_more: "更多",
  dbl_dashboard_list_tab_dashboard: '全部 ({count})',
  dbl_dashboard_list_tab_dashboard_no_count: '全部',
  dbl_dashboard_list_tab_my_dashboard: '我的报表 ({count})',
  dbl_dashboard_list_tab_share_with_me: '与我分享 ({count})',
  dbl_dashboard_list_tab_game_template: '游戏业务模板 ({count})',
  dbl_dashboard_list_tab_public_template: '公共业务模板 ({count})',
  dbl_dashboard_list_set_template: '设置模板',
  dbl_dashboard_list_template_type: '模板类型',
  dbl_dashboard_list_game_template: '游戏模板',
  dbl_dashboard_list_public_template: '公共模板',
  dbl_dashboard_list_template_name: '模板名称',
  dbl_dashboard_list_set_template_public_info: '具有',
  dbl_dashboard_list_set_template_game_info: '具有',
  dbl_dashboard_list_set_template_game_info_detail: '的用户可以在主页的模板中心查看报表。',
  dbl_dashboard_list_set_template_game_info_permissions: 'Datalab权限',
  dbl_dashboard_list_save_template: '另存为模板',
  dbl_dashboard_list_save_template_icon_info: '将报表设置为模板允许用户在主页模板中心和报表中心查看',
  dbl_dashboard_list_dashboard_placeholder: "请输入报表名称",
  dbl_dashboard_list_template_placeholder: "请输入模版名称",
  dbl_dashboard_list_template_set_success: "保存成功",

  dbl_dashboard_copy_title: "复制报表",
  dbl_dashboard_copy_name: "报表名称",
  dbl_dashboard_copy_charts_in: "报表中的图表",
  dbl_dashboard_copy_charts_in_info: "选择复制则同时新建图表，选择引用不新建图表",
  dbl_dashboard_copy_charts_in_refer: "引用图表",
  dbl_dashboard_copy_charts_in_copy: "复制图表",
  dbl_dashboard_copy_name_repeat: "报表名称已存在，请选择另一个",
  dbl_dashboard_copy_success: "复制成功！点击查看",
  dbl_dashboard_copy_fail: "复制失败",
};